import React from 'react';
import { TypedMemo } from '../../common/types';
import { EMBLEM_BARS, EMBLEM_TIGHT_ASPECT, EMBLEM_TIGHT_VIEW_BOX } from './music24BrandPaths';

export interface Music24LogoProps {
  /** The height in px. The width follows the emblem (a little narrower than high). */
  size?: number;
  className?: string;
}

/** The Music24 emblem (the 4 of bars), in a tight box. */
const Music24LogoComponent: React.FC<Music24LogoProps> = ({ size = 26, className }) => (
  <svg
    width={Math.round(size * EMBLEM_TIGHT_ASPECT * 100) / 100}
    height={size}
    viewBox={EMBLEM_TIGHT_VIEW_BOX}
    fill="none"
    className={className}
    style={{ display: 'block' }}
    aria-hidden
    data-testid="music24-emblem"
  >
    {EMBLEM_BARS.map((bar) => (
      <path key={bar.fill} fill={bar.fill} d={bar.d} />
    ))}
  </svg>
);

export const Music24Logo = TypedMemo(Music24LogoComponent);
